import getTokenBearer from '@/hooks/getTokenBearer';
import axios from 'axios';

const baseURL = import.meta.env.VITE_API_URL;
const mode = import.meta.env.VITE_MODE;
const loginViaProxy =
	import.meta.env.VITE_LOGIN_VIA_PROXY === 'true' ||
	(import.meta.env.DEV && baseURL && !String(baseURL).startsWith('/'));
const axiosInstance = axios.create({
	baseURL,
	headers: { 'Content-Type': 'multipart/form-data' },
});

/** customer-login/logout need site Referer in dev; Vite /bz-api/ proxy injects it. */
function customerAuthUrl(path) {
	const normalized = path.replace(/^\//, '');
	if (loginViaProxy) {
		return `/bz-api/${normalized}`;
	}
	return `${baseURL}${normalized}`;
}

function authSSO() {
	async function signInSSO(data) {
		const method = 'post';
		const response = await axiosInstance({
			method,
			url: 'login/',
			data,
		});
		return response;
	}
	async function signOutSSO(token) {
		const headers = {
			Authorization: `${getTokenBearer()} ${token}`,
			'Content-Type': 'multipart/form-data',
		};
		const response = await axios.post(
			`${baseURL}logout/`,
			{
				token,
				client_id: 'W08vGPLmig1Jyzktk8dsnIjsJNPfcbkr1CbRcZVc',
				client_secret:
					'WaBVvKswzHJ8vzlaIvPqVvAJrpNlbYWEaZj8IwxPkLLJCTPGtQuivQap17679bgZeP8J3zzK2XlDZN86D3xCP5PtRL5aJcqc1Z3WVmTY4DgcOoTmFW3iLjQhqIVUJrVj',
			},
			{ headers }
		);
		return response;
	}
	async function signin(data) {
		const loginReferer =
			import.meta.env.VITE_LOGIN_REFERER || 'https://njis.jungletoppings.com/';
		const headers = {
			Authorization: `basic ${btoa(`${data.username}:${data.password}`)}`,
			Referer: loginReferer,
			'Content-Type': 'application/json',
		};
		if (mode === 'production') {
			delete headers.Referer;
		}
		const response = await axios.post(customerAuthUrl('customer-login/'), {}, { headers });
		return response;
	}
	async function signout(token) {
		const headers = {
			Authorization: `${getTokenBearer()} ${token}`,
			'Content-Type': 'application/json',
		};
		const response = await axios.post(customerAuthUrl('customer-logout/'), { token }, { headers });
		return response;
	}

	return {
		signin,
		signout,
		signInSSO,
		signOutSSO,
	};
}

export default authSSO;
